import { render, staticRenderFns } from "./integrations-form-connect.vue?vue&type=template&id=8b0b388a"
import script from "./integrations-form-connect.vue?vue&type=script&lang=js"
export * from "./integrations-form-connect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports